import React from 'react';
import { motion } from 'framer-motion';
export function MainHeadline() {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className="text-center space-y-6" data-id="element-8">
      <h1 className="text-3xl md:text-5xl font-extrabold text-slate-900 leading-tight tracking-tight" data-id="element-9">
        TE ENTIENDO... QUIZÁS SOLO NECESITÁS LOS DISEÑOS POR AHORA.
      </h1>
      <p className="text-lg text-slate-700 leading-relaxed max-w-xl mx-auto" data-id="element-10">
        Entiendo que tal vez no necesites la calculadora profesional. Por eso,
        eliminamos los bonos para bajarte el precio al mínimo posible y que no
        te quedes afuera del Club de Tendencias.
      </p>
    </motion.div>;
}